import { ref } from 'vue'
import axios from 'axios'
import type { AxiosResponse } from 'axios'
import { defineStore } from 'pinia'

interface Account {
  id: string
  name: string
  kind: 'facebook' | 'instagram' | 'twitter'
  type: 'facebook' | 'instagram' | 'twitter'
  username: string
  picture: {
    url: string
  }
  connected_user_name: string
}

interface Response {
  data: {
    accounts: Account[]
  }
}

interface Payload {
  companyUuid: string
}

export const useSnsAccountsStore = defineStore('snsAccounts', () => {
  const loading = ref<boolean>(false)
  const data = ref<Account[]>([])

  const prepareConnect = () => {
    loading.value = true
  }
  const stopConnect = () => {
    loading.value = false
  }

  const readSnsAccountsSuccess = (res: Response): void => {
    data.value = res.data.accounts.map((v: Account) =>{
      return {...v, type: v.kind}
    })
    stopConnect()
  }

  const readSnsAccounts = (payload: Payload): Promise<void> => {
    const { companyUuid } = payload
    prepareConnect()
    return axios
      .get(`/api/companies/${companyUuid}/sns/accounts.json`)
      .then((res: AxiosResponse<Response>) => {
        readSnsAccountsSuccess(res.data)
      })
      .catch(err => {
        stopConnect()
        console.error('error', err)
      })
  }
  return { data, loading, readSnsAccounts }
})
